import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { niches } from '../niches';
import NicheHero from '../components/niche/NicheHero';
import NicheServices from '../components/niche/NicheServices';
import NicheWhyMe from '../components/niche/NicheWhyMe';
import NicheFaq from '../components/niche/NicheFaq';
import NicheCTA from '../components/niche/NicheCTA';
import { useSeo } from '../lib/useSeo';
import { useJsonLd } from '../lib/useJsonLd';

export default function NicheLandingPage() {
  const { slug } = useParams<{ slug: string }>();
  const config = slug ? niches[slug] : undefined;

  useSeo({
    title: config ? config.meta.title : 'Nie znaleziono strony - DAIEN',
    description: config?.meta.description ?? 'Ta strona nie istnieje.',
    path: config ? `/lp/${config.slug}` : '/',
    noindex: !config,
  });

  // LocalBusiness per strona lokalna - sygnal "firma AI w tym miescie" dla LLM.
  useJsonLd(
    'ld-localbusiness',
    config?.areaServed
      ? {
          '@context': 'https://schema.org',
          '@type': ['ProfessionalService', 'LocalBusiness'],
          name: 'DAIEN',
          url: `https://daien.pl/lp/${config.slug}`,
          telephone: '+48573352695',
          email: 'dawid@daien.pl',
          areaServed: config.areaServed,
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'ul. Żelazna 14',
            addressLocality: 'Gdynia',
            postalCode: '81-150',
            addressCountry: 'PL',
          },
          geo: { '@type': 'GeoCoordinates', latitude: 54.5189, longitude: 18.5305 },
        }
      : null,
  );

  useEffect(() => {
    if (!config) return;
    window.scrollTo(0, 0);
    // page view sledzony globalnie w App.tsx (useLocation)
  }, [config]);

  if (!config) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-bg text-text-primary">
      <NicheHero config={config} />
      <NicheServices config={config} />
      <NicheWhyMe config={config} />
      {config.faq && <NicheFaq faq={config.faq} />}
      <NicheCTA config={config} />
    </div>
  );
}
